import { Component, OnInit, Output, EventEmitter, Inject, ChangeDetectorRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DocumentDetail } from "../../../models/order.model";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  DateAdapter,
  MAT_DATE_FORMATS
} from "@angular/material";
import {
  AppService,
  AppDateAdapter,
  APP_DATE_FORMATS
} from "../../../services/app.service";
import { OrderService } from "../../../services/order.service";
import { SecDatatable } from "../../../models/datatable.model";
import { SharedService } from "../../../services/shared";
import { environment } from "../../../../../../environments/environment";
import { SecondaryDatatableComponent } from "../../secondary-datatable/secondary-datatable.component";
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

@Component({
  selector: "app-document-detail",
  templateUrl: "./document-detail.component.html",
  styleUrls: ["./document-detail.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ]
})
export class DocumentDetailComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  userId: Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  doc = new DocumentDetail();
  translations: any;
  pageIndex: Number = 0;
  pageSize: Number = 10;
  filterText: String = "";
  sortDirection: String = "asc";
  sortHeaderName: String = "Id";
  sortColumnNameById: String = "Id";
  length: Number = 0;
  public orderId: any = 0;
  documnetData : any;
  fileList: any = [];
  imageFileType: any = ["png", "PNG", "jpg", "JPG", "jpeg", "JPEG"];
  selectedFileCount: Number = 0;
  blobOrFileList: any = [];
  noChangesFile = 0;
  orderNo = '';
  public files: UploadFile[] = [];
  sameFileCount = 0;
  duplicatefile = '';
  constructor(
    private ref: ChangeDetectorRef,
    private orderService: OrderService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public appService: AppService,
    private statusCodeService: OrderService,
    private datatableProp: SecDatatable,
    private datatableComponent: SecondaryDatatableComponent,
    private sharedService: SharedService,
    public dialogRef: MatDialogRef<DocumentDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
      DocumentName: {},
      DocumentNumber: {},
      RegistrationDate: {},
      Description: {},
      FilePath: {}
      // FileName:{},
    };

    this.formGroup = this.formBuilder.group({
      DocumentName: ["", Validators.required],
      DocumentNumber: [
        {
          value: "",
          disabled: true
        }
      ],
      RegistrationDate: ["", Validators.required],
      Description: ["", Validators.required],
      FilePath: ["", Validators.required],
      SendInApi: [false]
    });
    this.noChangesFile = 0;
    this.orderId = window.sessionStorage.getItem("orderId");
    this.doc.RegistrationDate = new Date();
  }
  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }
  getOrderDocument(): void {
    this.formGroup.reset();
    this.orderService
      .allDocument(
        this.orderId,
        this.pageIndex,
        this.pageSize,
        this.sortColumnNameById,
        this.sortDirection,
        this.filterText
      )
      .subscribe(
        res => this.getOrderDocumentSuccess(res),
        error => this.apiFaillure(error)
      );
  }
  getOrderDocumentSuccess(res) {
    this.documnetData = [];
    if (res.Status) {
      this.orderNo = JSON.parse(res.Data).Table3[0]['OrderNo'];
      this.documnetData = JSON.parse(res.Data).Table;
      this.datatableProp.displayedColumns = [];
      this.datatableProp = this.appService.mapDataTableProp(
        this.datatableProp,
        JSON.parse(res.Data).Table1[0]
      );
      this.datatableProp.iscustom = false;
      this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
      this.length =
        this.documnetData.length == 0
          ? 0
          : JSON.parse(res.Data).Table[0].MaxRowNumber;
      
      this.sharedService.documnetData.next(this.documnetData);
      
      this.appService.hideLoading();
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }
  ngOnInit() {
    this.appService.showLoading();
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(
        this.formGroup,
        this.formGroupErrors
      );
    });
    this.getOrderDocument();
  }

  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue("Error", error);
  }
  close() {
    this.close();
  }
  saveDocumentSuccess(res) {
    this.appService.hideLoading();
    if (res.Status) {
      this.appService
        .showDialogue(
          this.translations.hdSuccess,
          this.translations[res.Message]
        )
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.doc = new DocumentDetail();
            this.getOrderDocument();
            this.fileList = [];
            this.blobOrFileList = [];
          }
        });
    } else {
      this.apiFaillure(res.Message);
    }
  }
  save(): void {
    this.noChangesFile = 0;
    this.appService.showLoading();
    this.uploadFile();
    if (this.noChangesFile == this.fileList.length) {
      this.doc.OrderId = this.orderId;
      this.doc.Files = this.fileList;
      this.orderService
        .saveDocument(JSON.stringify(this.doc))
        .subscribe(
          res => this.saveDocumentSuccess(res),
          error => this.apiFaillure(error)
        );
    }
  }
  uploadFile() {
    for (let i = 0; i < this.fileList.length; i++) {
      this.transferFileToServer(i);
    }
  }

  transferFileToServer(index) {
    if (this.fileList[index].HttpPath != "") {
      this.noChangesFile++;
      return;
    }
    let blobOrFile: any;
    for (let i = 0; i < this.blobOrFileList.length; i++) {
      if (this.blobOrFileList[i].name == this.fileList[index].FileName) {
        blobOrFile = this.blobOrFileList[i];
      }
    }

    let that = this;
    var xhr = new XMLHttpRequest();
    xhr.open("POST", environment.apiUrl + "File.svc/Upload/", true);
    xhr.setRequestHeader(
      "FileExtention",
      "." + blobOrFile.name.substr(blobOrFile.name.lastIndexOf(".") + 1)
    );
    xhr.setRequestHeader("FileId", this.fileList[index].Id.toString());
    xhr.upload.onprogress = function(e) {
      if (e.lengthComputable) {
        that.fileList[index].Progress = e.loaded / e.total * 100;
      }
    };
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4 && xhr.status == 200) {
        let responseObject = JSON.parse(xhr.responseText);
        that.fileList[index].Progress = 100;
        //that.fileList[index].FileName = responseObject.FileName;
        that.fileList[index].AbsolutePath = responseObject.AbsolutePath;
        that.fileList[index].HttpPath = responseObject.HttpPath;
        that.fileList[index].Status = true;

        let uploadedFileCount = 0;
        for (let i = 0; i < that.fileList.length; i++) {
          if (that.fileList[i].HttpPath != "") {
            uploadedFileCount++;
          }
        }
        if (uploadedFileCount == that.fileList.length) {
          that.doc.OrderId = that.orderId;
          that.doc.Files = that.fileList;
          that.orderService
            .saveDocument(JSON.stringify(that.doc))
            .subscribe(
              res => that.saveDocumentSuccess(res),
              error => that.apiFaillure(error)
            );
        }
      }
    };
    xhr.send(blobOrFile);
  }
  openFileDialogue() {
    document.getElementById("fileInput").nodeValue = "";
    document.getElementById("fileInput").click();
  }
  fileChangeEvent(fileInput: any) {
    
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.selectedFileCount = fileInput.target.files.length;
      this.sameFileCount = 0;
      
      for (var i = 0; i < fileInput.target.files.length; i++) {
        let blobOrFile = fileInput.target.files[i];         
        this.queueFile(blobOrFile,i);
      }

      if(this.sameFileCount > 0){
        this.appService.showDialogue("Warning",this.translations.msgDuplicateDocument + '(' + this.duplicatefile + ')');        
      }
    }
    let f = document.getElementById("fileInput");
    f['value'] = "";
  }
  removeFrmList(file) {
    this.fileList = this.fileList.filter(function(el) {
      return el.FileName != file.FileName;
    });
    this.blobOrFileList = this.blobOrFileList.filter(function(el) {
      return el.name != file.FileName;
    });

    this.doc.FilePath = "";
    for (let itmCount = 0; itmCount < this.fileList.length; itmCount++) {
      this.doc.FilePath += this.fileList[itmCount].FileName + ",";
    }
  }

  changeFileStatus(file, status) {
    for (let itmCount = 0; itmCount < this.fileList.length; itmCount++) {
      if (this.fileList[itmCount].Id == file.Id) {
        this.fileList[itmCount].Status = status;
      }
    }
  }
  addRecord() {
    this.formGroup.reset();
    this.appService.hideLoading();
    this.doc = new DocumentDetail();
    this.doc.RegistrationDate = new Date();
    this.fileList = [];
    this.blobOrFileList = [];
    let f = document.getElementById("fileInput");
    f['value'] = "";
  }
  deleteRecord(e): void {
    var documentId = e.currentTarget.id;
    this.appService
      .showDialogue(
        this.translations.hdConfirm,
        this.translations.confrimMessage,
        true
      )
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.appService.showLoading();
          this.deleteConfirm(documentId);
        }
      });
  }

  deleteConfirm(documentId) {
    this.orderService
      .deleteDocument(documentId)
      .subscribe(
        res => this.deleteSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  deleteSuccess(res) {
    this.appService.hideLoading();
    this.noChangesFile = 0;
    if (res.Status == 1) {
      this.appService
        .showDialogue(
          this.translations.hdSuccess,
          this.translations[res.Message]
        )
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.appService.hideLoading();
            this.doc = new DocumentDetail();
            this.getOrderDocument();
            this.fileList = [];
            this.blobOrFileList = [];
          }
        });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  editRecord(e): void {
    this.appService.showLoading();
    this.doc = new DocumentDetail();
    this.fileList = [];
    this.blobOrFileList = [];
    this.orderService
      .selectDocument(e.currentTarget.id)
      .subscribe(
        res => this.selectDocumentSuccess(res),
        error => this.apiFaillure(error)
      );
  }
  selectDocumentSuccess(res) {
    this.noChangesFile = 0;
    this.doc = new DocumentDetail();
    this.fileList = [];
    this.doc.FilePath = "";
    if (res.Status == 1) {
      this.doc = JSON.parse(res.Data).Table[0];
      this.fileList = JSON.parse(res.Data).Table1;
      this.doc.FilePath = "";
      for (let itmCount = 0; itmCount < this.fileList.length; itmCount++) {
        this.doc.FilePath += this.fileList[itmCount].FileName + ",";
      }
      this.appService.hideLoading();
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  fileOver(event){
    
    event.preventDefault();
  }
 
  fileLeave(event){
    
    event.preventDefault();
  }

  dropped(event: UploadEvent) {
    
    this.files = event.files;
    let i = -1;
    this.sameFileCount = 0;
    for (const droppedFile of event.files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          i++;
          // Here you can access the real file
          console.log(droppedFile.relativePath, file);
          this.queueFile(file,i);      
        });
       
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
    
  }

  queueFile(blobOrFile,i){
    
    for (let j = 0; j < this.fileList.length; j++) {
      if (this.fileList[j].FileName == blobOrFile.name) {
        this.sameFileCount++;
        this.duplicatefile = this.duplicatefile + "," + this.fileList[j].FileName;
      }
    }
   
    let filetype = blobOrFile.name.substr(
      blobOrFile.name.lastIndexOf(".") + 1
    );
    this.blobOrFileList.push(blobOrFile);
    this.fileList.push({
      Id: i + 1,
      FileName: blobOrFile.name,
      FileType: filetype,
      Progress: 0,
      AbsolutePath: "",
      Status: true,
      HttpPath: ""
    });
    setInterval(() => {
      this.ref.detectChanges();
    }, 500);
    this.doc.FilePath += blobOrFile.name + ",";
    
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/document-detail/document-detail.component.ts